import { Component, inject, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { lastValueFrom, Observable, Subscription } from "rxjs";
import { AuthService } from "../../services/auth.service";
import { first } from "rxjs/operators";
import { AuthState } from "../../models/auth.model";
import { UserService } from "src/app/services/api/user.service";
import { SweetAlertService } from "src/app/services/sweet-alert-service/sweet-alert.service";
import { ToastService } from "src/app/services/toast-service/toast.service";
import { TranslateService } from "@ngx-translate/core";

enum ErrorStates {
  NotSubmitted,
  HasError,
  NoError,
}

@Component({
  selector: "app-forgot-password",
  templateUrl: "./forgot-password.component.html",
  styleUrls: ["./forgot-password.component.scss"],
  standalone: false,
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordForm: FormGroup;
  errorState: ErrorStates = ErrorStates.NotSubmitted;
  errorStates = ErrorStates;
  isLoading$: Observable<boolean>;

  AuthStates = AuthState;

  #swalService = inject(SweetAlertService);
  #userService = inject(UserService);
  #authService = inject(AuthService);
  #toastService = inject(ToastService);
  #translate = inject(TranslateService);

  // private fields
  private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
  constructor(private fb: FormBuilder, private authService: AuthService) {
    this.isLoading$ = this.authService.isLoading$;
  }

  ngOnInit(): void {
    this.initForm();
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.forgotPasswordForm.controls;
  }

  initForm() {
    this.forgotPasswordForm = this.fb.group({
      email: [
        null,
        Validators.compose([
          Validators.required,
          Validators.email,
          Validators.minLength(3),
          Validators.maxLength(320),
        ]),
      ],
    });
  }

  submit() {
    // this.errorState = ErrorStates.NotSubmitted;
    // const forgotPasswordSubscr = this.authService
    //   .forgotPassword(this.f.email.value)
    //   .pipe(first())
    //   .subscribe((result: boolean) => {
    //     this.errorState = result ? ErrorStates.NoError : ErrorStates.HasError;
    //   });
    // this.unsubscribe.push(forgotPasswordSubscr);
  }
  async resetRequest() {
    // this.notifierService.notify('default', 'ระบบยังไม่พร้อมใช้งาน');
    await this.#swalService.swalConfirmation();
    const email = this.forgotPasswordForm.getRawValue().email;
    try {
      this.#swalService.swalLoading();
      const reset = await lastValueFrom(
        this.#userService.requestToReset(email)
      );
      this.#swalService.swalClose();
      this.#swalService.swalSuccess(
        this.#translate.instant("APP.SEND_EMAIL_DESC"),
        " "
      );
    } catch (error: any) {
      this.showError(error.error.error);
    }
  }

  showError(code: string): void {
    switch (code) {
      case "CP03":
        this.#toastService.toastError(
          this.#translate.instant(
            this.#translate.instant("VALIDATOR.CHANGE_PASSWORD_DUPLICATED")
          )
        );
        break;
      case "CP04":
        this.#toastService.toastError(
          this.#translate.instant("VALIDATOR.CHANGE_PASSWORD_INVALID")
        );
        break;
      default:
        this.#toastService.toastError(
          this.#translate.instant("VALIDATOR.CHANGE_PASSWORD_ERROR")
        );
    }
  }

  updateAuthState(state: AuthState) {
    this.authService.updateAuthState(state);
  }
}
